import { render, staticRenderFns } from "./BusinessMemberPlanCancel.vue?vue&type=template&id=3810a948"
import script from "./BusinessMemberPlanCancel.vue?vue&type=script&lang=js"
export * from "./BusinessMemberPlanCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports